export default __webpack_public_path__ + "node_modules/font-awesome/fonts/fontawesome-webfont.eot";